import PropTypes from 'prop-types'
import styled, { keyframes } from 'styled-components'

const sizes = {
  small: '15px',
  medium: '25px',
  large: '50px'
}
const borderWidths = {
  small: '2px',
  medium: '3px',
  large: '3px'
}
const spin = keyframes`
  to {
    transform: rotate(360deg);
  }
`
const StyledSpinner = styled.span`
  display: block;
  content: '';
  box-sizing: border-box;
  width: ${({ size }) => sizes[size]};
  height: ${({ size }) => sizes[size]};
  background-color: transparent;
  border-radius: 50%;
  border: 4px solid rgba(255, 255, 255, 1);
  border-width: ${({ size }) => borderWidths[size]};
  border-color: ${({ color }) => color};
  border-bottom-color: rgba(255, 255, 255, 0);
  animation: ${spin} 1s linear infinite;
`
/**
 * The Spinner component provides a visual cue that there is an ongoing background process.
 */
const Spinner = ({ size = 'small', color = '#fff', ...rest }) => (
  <StyledSpinner size={size} color={color} {...rest} />
)

Spinner.propTypes = {
  /** Determines the size of the loader. */
  size: PropTypes.oneOf(['small', 'medium', 'large']),
  /** Determines the color. Any string that is a valid CSS color value. */
  color: PropTypes.string
}

export { Spinner }
